module.exports = __webpack_public_path__ + "img/course_0010.a07e1fc.webp";